/*
 * The server keys dialog's sentences, in one place so server-keys-copy.test.ts can hold them
 * to the house rules (no em or en dashes). What a key can do is said the same way on every
 * screen that asks someone to create or revoke one.
 */
const CAN_DO = "read this website's server-side experiment setup and report conversions from your backend";

export const SERVER_KEYS_COPY = {
  button: 'Server keys',
  title: 'Server keys',
  description: `A server key lets your backend use the Pertento SDK. It can ${CAN_DO}. Keep it on your server, never in a page.`,
  salt: "A key also gives access to this website's bucketing salt. If you bucket on customer ID, send opaque IDs, not sequential ones such as database row numbers.",
  visitorIdOff:
    'Turn on the visitor ID for this website, under Settings, to create a key. Existing keys keep working until you revoke them.',
  nameLabel: 'Key name',
  namePlaceholder: 'production',
  nameHelp: 'Name each key after where it runs, such as production or staging.',
  nameTooLong: 'A key name is at most 64 characters.',
  nameTaken: 'This website already has an active key with that name.',
  create: 'Create key',
  createTitle: (url: string) => `Create a server key for ${url}?`,
  createBody: `Anyone holding the key can ${CAN_DO}. Owners and Admins of this account are notified.`,
  secretTitle: 'Your new key',
  secretOnce: 'You will not see this again. Copy it into your server secrets now.',
  secretActive: 'It becomes active within about 30 seconds.',
  copy: 'Copy',
  copied: 'Copied',
  copyFailed: 'Could not copy. Select the key and copy it yourself.',
  empty: 'No keys yet.',
  loadFailed: 'Could not load the keys.',
  retry: 'Try again',
  tableLabel: 'Server keys',
  columns: { name: 'Name', prefix: 'Key', created: 'Created', lastUsed: 'Last used', status: 'Status' },
  never: 'Never',
  active: 'Active',
  revoked: (when: string) => `Revoked ${when}`,
  revoke: 'Revoke',
  revokeTitle: (name: string, url: string) => `Revoke "${name}" for ${url}?`,
  revokeBody: `Code using this key stops working within about 30 seconds: it can no longer ${CAN_DO}. Owners and Admins of this account are notified. This cannot be undone.`,
} as const;
